// Item types
export const ITEM_CATEGORIES = [
    'Electronics',
    'Furniture',
    'Clothing',
    'Kitchen',
    'Tools',
    'Sports',
    'Collectibles',
    'Books',
    'Toys',
    'Outdoor',
    'Office',
    'Other',
];
export const ITEM_CONDITIONS = [
    'new',
    'open_box',
    'like_new',
    'good',
    'fair',
    'poor',
];
export const ITEM_CONDITION_LABELS = {
    new: 'New',
    open_box: 'Open Box',
    like_new: 'Like New',
    good: 'Good',
    fair: 'Fair',
    poor: 'Poor',
};
//# sourceMappingURL=item.js.map